"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _http = require("./http.js");

var _sweetalert = _interopRequireDefault(require("sweetalert2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var uploadConfig = {
  headers: {
    post: {
      'Content-Type': 'multipart/form-data'
    }
  }
};

function postWithUploadFile(url, data, config) {
  var formData = new FormData();

  for (var i of Object.keys(data)) {
    formData.append(i, data[i]);
  }

  return post(url, formData, Object.assign({}, uploadConfig, config));
}

function post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return _http.http.post(url, data, config);
}

function put(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return _http.http.put(url, data, config);
}

function remove(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return _http.http.delete(url, data, config);
}

function get(url, dataInParams) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var generatedConfig = {
    params: dataInParams
  };
  config = Object.assign({}, config, generatedConfig);
  return _http.http.get(url, config);
}

function patch(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return _http.http.patch(url, data, config);
}

function fastQuestion(_x, _x2, _x3, _x4, _x5) {
  return _fastQuestion.apply(this, arguments);
}
/**
 *
 * @param title
 * @param input
 * @param url
 * @param dataName
 * @param dataObj
 * @param callback
 */


function _fastQuestion() {
  _fastQuestion = _asyncToGenerator(function* (title, input, url, dataName, dataObj) {
    return yield _sweetalert.default.fire({
      title: title,
      input: input,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Zurück',
      confirmButtonText: 'Bestätigen',
      showLoaderOnConfirm: true,
      preConfirm: data => {
        dataObj[dataName] = data;
        return post(url, dataObj).then(response => {
          return response;
        });
      },
      allowOutsideClick: () => !_sweetalert.default.isLoading()
    });
  });
  return _fastQuestion.apply(this, arguments);
}

function fastSweetAlertRequest(_x6, _x7, _x8, _x9, _x10) {
  return _fastSweetAlertRequest.apply(this, arguments);
}
/**
 * get without slient
 * @param url
 * @param dataInParams
 * @param config
 * @returns {Promise<AxiosResponse<any>>}
 */


function _fastSweetAlertRequest() {
  _fastSweetAlertRequest = _asyncToGenerator(function* (title, input, url, dataName, dataObj) {
    var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    dataObj[dataName] = '';
    return yield _sweetalert.default.fire({
      title: title,
      input: input,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Zurück',
      confirmButtonText: 'Bestätigen',
      showLoaderOnConfirm: true,
      preConfirm: data => {
        dataObj[dataName] = data;
        return post(url, dataObj).then(response => {
          console.log(response);

          if (callback) {
            callback();
          }
        });
      },
      allowOutsideClick: () => !_sweetalert.default.isLoading()
    });
  });
  return _fastSweetAlertRequest.apply(this, arguments);
}

function silentGet(url, dataInParams, config) {
  return get(url, dataInParams, Object.assign({
    silent: true
  }, config));
}
/**
 * Post Use Json
 * @param url
 * @param dataInParams
 * @param config
 * @returns {Promise<AxiosResponse<any>>}
 */


function jsonPost(url, dataInParams, config) {
  return post(url, dataInParams, Object.assign({}, _http.jsonConfig, config));
}

var _default = _objectSpread(_objectSpread({
  axios: _http.http
}, _http.http), {}, {
  fastQuestion,
  post,
  fastSweetAlertRequest,
  get,
  postWithUploadFile,
  put,
  remove,
  silentGet,
  jsonPost
});

exports.default = _default;